export let currencies = [
    'USD',
    'EUR',
    'PLN',
    'JPY',
    'CNY',
    'SDG',
    'RON',
    'MKD',
    'MXN',
    'CAD',
    'ZAR',
    'AUD',
    'NOK',
    'ILS',
    'ISK',
    'SYP',
    'LYD',
    'UYU',
    'YER',
    'CSD',
    'EEK',
    'THB',
    'IDR',
    'LBP',
    'AED',
    'BOB',
    'QAR',
    'BHD',
    'HNL',
    'HRK',
    'COP',
    'ALL',
    'DKK',
    'MYR',
    'SEK',
    'RSD',
    'BGN',
    'DOP',
    'KRW',
    'LVL',
    'VEF',
    'CZK',
    'TND',
    'KWD',
    'VND',
    'JOD',
    'NZD',
    'PAB',
    'CLP',
    'PEN',
    'GBP',
    'DZD',
    'CHF',
    'RUB',
    'UAH',
    'ARS',
    'SAR',
    'EGP',
    'INR',
    'PYG',
    'TWD',
    'TRY',
    'BAM',
    'OMR',
    'SGD',
    'MAD',
    'BYR',
    'NIO',
    'HKD',
    'LTL',
    'SKK',
    'GTQ',
    'BRL',
    'HUF',
    'IQD',
    'CRC',
    'PHP',
    'SVC'
];